import { createAsyncThunk } from '@reduxjs/toolkit';

import COMMON_API from './common.api'

export const uploadFileAction = createAsyncThunk<any, Common.UploadFilePayload>(
  'uploadFile',
  async ({ data, callback = () => {} }, { dispatch, rejectWithValue }) => {
    try {
      const res = await COMMON_API.uploadFileAPI(data)
      return res
    } catch (err: any) {
      return rejectWithValue(err)
    }
  }
)

